<template>
  <div id="mapContainer"></div>
</template>

<script>
import { setColorByValue, setColorByCategory } from "../../util";
import countryISO3 from "../assets/ISO3.json";
export default {
  props: {
    data: Array,
    map: Object,
    popup: Object,
    variable: String,
    minmax: Array,
  },
  data() {
    return { countryISO3 };
  },
  watch: {
    map(map) {
      if (map) this.initMap();
    },
    data(newdata) {
      this.formatMap(newdata);
      this.repaintRegion(newdata);
    },
  },
  methods: {
    initMap() {
      const { map, data } = this;
      map.on("load", () => {
        this.formatMap(data);
        this.repaintRegion(data);
        map
          .on("mousemove", "country-shape", this.mousemoveRegion)
          .on("mouseleave", "country-shape", this.mouseleaveRegion);
      });
    },
    formatMap(data) {
      const { map } = this;
      let regions = data.map((d) => d.ISO3);
      const tofindDuplicates = (arry) =>
        arry.filter((item, index) => regions.indexOf(item) !== index);
      const duplicateElementa = tofindDuplicates(regions);
      map
        .setFilter("country-bubble", [
          "match",
          ["get", "ISO3"],
          regions,
          true,
          false,
        ])
        .setFilter("country-bubble-label", [
          "match",
          ["get", "ISO3"],
          regions,
          true,
          false,
        ]);
    },
    repaintRegion(data) {
      const { map, variable, minmax } = this;
      if (variable === "regulation") {
        map
          .setPaintProperty(
            "country-shape",
            "fill-color",
            setColorByCategory(data)
          )
          .setPaintProperty(
            "country-bubble",
            "circle-color",
            setColorByCategory(data)
          );
      } else {
        map
          .setPaintProperty("country-shape", "fill-color", [
            "interpolate",
            ["exponential", 0.5],
            ["zoom"],
            2.3,
            setColorByValue(data, minmax, variable),
            3,
            "#fff",
          ])
          .setPaintProperty(
            "country-bubble",
            "circle-color",
            setColorByValue(data, minmax, variable)
          );
      }
    },
    mousemoveRegion(e) {
      const { map, popup, data } = this;
      let { ISO3 } = e.features[0].properties;
      const selectedCountry = data.filter((d) => d.ISO3 === ISO3)[0];
      if (!selectedCountry) return;
      const { tooltip, tempvalue } = this.formatTooltip(selectedCountry);
      if (tempvalue) this.$emit("handle-map-value", tempvalue);
      map.getCanvas().style.cursor = "pointer";
      popup.setLngLat([e.lngLat.lng, e.lngLat.lat]).setHTML(tooltip).addTo(map);
    },
    mouseleaveRegion() {
      const { map, popup } = this;
      this.$emit("handle-map-value", null);
      map.getCanvas().style.cursor = "";
      popup.remove();
    },
    formatTooltip(country) {
      const { variable } = this;
      let name = countryISO3.filter((d) => d.ISO3 === country.ISO3)[0].region;
      let regulationtext = [
        "End-user price is fixed",
        "End-user price is not fully fixed nor liberalized",
        "End-user price is fully liberalized",
      ];
      let textByVariable = {
        price: `${country.value.toFixed(2)} USD per litre`,
        regulation: `${regulationtext[country.value - 1]}`,
        tax: `${country.value.toFixed(0)}&nbsp;%`,
        carbon: `${country.value.toFixed(0)}&nbsp;%`,
      };
      return {
        tempvalue: country.value,
        tooltip: `
          <b><span>${name}</span></b><br/>
          ${textByVariable[variable]}
        `,
      };
    },
  },
};
</script>

<style>
#mapContainer {
  width: 100%;
  height: 100%;
}
.mapContainer-popup-class {
  font-family: Graphik;
  font-size: 0.9rem;
  max-width: unset !important;
}
.mapContainer-popup-class > * {
  margin: 0;
}
.mapContainer-popup-class span {
  font-size: 0.8rem;
}
.mapContainer-popup-class b {
  font-weight: 600;
}
</style>
